import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Layout.css';

const WHATSAPP_URL =
  'https://wa.me/5522999611338?text=' +
  encodeURIComponent(
    'Olá! Eu estou vindo do site e gostaria de mais informações sobre os seus planos.'
  );

const Layout = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [showCookieBanner, setShowCookieBanner] = useState(true);

  useEffect(() => {
    // Verificar se o usuário está logado (simulado)
    const loggedInUser = localStorage.getItem('loggedInUser');
    if (loggedInUser) {
      setIsLoggedIn(true);
      setUserData(JSON.parse(loggedInUser));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('loggedInUser');
    setIsLoggedIn(false);
    setUserData(null);
  };

  const handleCentralAssinanteClick = () => {
    // Redirecionar para o Central do Assinante na URL de produção
    window.open('/centraldoassinante', '_blank');
  };

  const handleCookieAccept = () => {
    setShowCookieBanner(false);
    localStorage.setItem('cookiesAccepted', 'true');
  };

  return (
    <div className="layout">
      {/* Header */}
      <header className="header">
        <div className="header-container">
          <div className="logo">
            <Link to="/">
              <img src="/logo.png" alt="UNET" />
            </Link>
          </div>
          
          <nav className="nav">
            <Link to="/" className="nav-link">Início</Link>
            <a href="#planos" className="nav-link">Planos</a>
            <Link to="/suporte" className="nav-link">Suporte</Link>
            <Link to="/contratos" className="nav-link">Contratos</Link>
            <a
              href={WHATSAPP_URL}
              className="nav-link nav-whatsapp"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-whatsapp" aria-hidden="true" /> WhatsApp
            </a>
            
            {isLoggedIn ? (
              <div className="user-menu">
                <button className="user-button">
                  Olá, {userData?.name || 'Usuário'}
                  <span className="dropdown-arrow">▼</span>
                </button>
                <div className="dropdown-menu">
                  <button onClick={() => window.open('/centraldoassinante/dashboard', '_blank')}>
                    Dashboard
                  </button>
                  <button onClick={() => window.open('/centraldoassinante/dashboard/boletos', '_blank')}>
                    Faturas
                  </button>
                  <button onClick={() => window.open('/centraldoassinante/dashboard/pagamentos', '_blank')}>
                    Pagamentos
                  </button>
                  <button onClick={() => window.open('/centraldoassinante/dashboard/profile', '_blank')}>
                    Perfil
                  </button>
                  <button onClick={handleLogout}>
                    Sair
                  </button>
                </div>
              </div>
            ) : (
              <button 
                className="central-assinante-btn"
                onClick={handleCentralAssinanteClick}
              >
                Central do Assinante
              </button>
            )}
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="main-content">
        {children}
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3>UNET</h3>
            <p>Internet de alta velocidade para sua casa e empresa.</p>
          </div>
          <div className="footer-section">
            <h4>Contato</h4>
            <p>📞 (22) 3012-7144 / (22) 99961-1338</p>
            <p>
              <a
                href={WHATSAPP_URL}
                className="footer-whatsapp-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-whatsapp" aria-hidden="true" /> Chamar no WhatsApp
              </a>
            </p>
            <p>📧 contato@unetbandalarga.com.br</p>
          </div>
          <div className="footer-section">
            <h4>Endereço</h4>
            <p>Rua Engenheiro Luiz Carlos Gomes Carvalho, 211</p>
            <p>Ururai - Campos dos Goytacazes - RJ</p>
          </div>
          <div className="footer-section">
            <h4>Links Úteis</h4>
            <a href="#planos">Planos</a>
            <Link to="/suporte">Suporte</Link>
            <Link to="/contratos">Contratos</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 UNET. Todos os direitos reservados.</p>
        </div>
      </footer>

      {/* Cookie Banner */}
      <a
        href={WHATSAPP_URL}
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Abrir conversa no WhatsApp com a UNET"
        title="Fale conosco no WhatsApp"
      >
        <i className="fab fa-whatsapp" aria-hidden="true" />
      </a>

      {showCookieBanner && !localStorage.getItem('cookiesAccepted') && (
        <div className="cookie-banner">
          <div className="cookie-content">
            <p>
              Utilizamos cookies para melhorar sua experiência. 
              Ao continuar navegando, você concorda com nossa política de cookies.
            </p>
            <button onClick={handleCookieAccept} className="cookie-btn">
              Aceitar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Layout; 